import { render, staticRenderFns } from "./QuestionOneAnswer.vue?vue&type=template&id=208a9fec&scoped=true&"
import script from "./QuestionOneAnswer.vue?vue&type=script&lang=js&"
export * from "./QuestionOneAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208a9fec",
  null
  
)

export default component.exports